<template>
    <BasicModal title="Share" @close="$emit('close')">
        <ShareFriends :item-id="itemId" :item-type="itemType" />
    </BasicModal>
</template>

<script>
import BasicModal from "js/components/modals/BasicModal";
import ShareFriends from "js/components/common/ShareFriends";

export default {
    name: "ShareFriendsModal",
    components: { BasicModal, ShareFriends },
    props: {
        itemId: {
            type: Number,
            default: null,
        },
        itemType: {
            type: String,
            default: null,
        },
    },
    emits: ["close"],
};
</script>
